"use client";
import * as React from "react";
const SvgBuildFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m15.79 13.08-6.6-6.65a4.77 4.77 0 0 0-6.46-6l3.11 3.15-2.18 2.2-3.2-3.15a4.7 4.7 0 0 0 .95 5.4 4.6 4.6 0 0 0 5.01 1.1l6.61 6.65a.7.7 0 0 0 1.02 0l1.67-1.68c.36-.3.36-.8.07-1.02" }));
export {
  SvgBuildFilled as default
};
